<div class="card mt-1">
    <div class="card-header" id="heading{{ bloque.IdBloque }}" aria-expanded="true">
        <div class="row">
            <div class="col-md-9">
                <h3 style="cursor: pointer;" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + bloque.IdBloque" [attr.aria-controls]="'collapse' + bloque.IdBloque">{{ bloque.Nombre }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h6>Calificación: <span>{{ bloque.Calificacion }}</span></h6>
            </div>
        </div>
    </div>

    <div id="collapse{{ bloque.IdBloque }}" class="collapse hide" [attr.aria-labelledby]="'heading' + bloque.IdBloque" data-parent="#accordionExample">
        <div class="card-body">
            <app-rubro [global]="global" [rubro]="rubro" *ngFor="let rubro of bloque.Rubros"></app-rubro>
        </div>
    </div>
</div>
